import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import FormatListNumberedOutlinedIcon from '@mui/icons-material/FormatListNumberedOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import logo from '../../../assets/230616_RV_logo_restrito_negativo-branco.png';

import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import SignalCellularAltOutlinedIcon from '@mui/icons-material/SignalCellularAltOutlined';
import ImportContactsOutlinedIcon from '@mui/icons-material/ImportContactsOutlined';

import './Sidebar.css';

function Sidebar() {

  const [firstAccess, setFirstAccess] = useState(true);
  const [rankingEnable, setRankingEnable] = useState(false);
  const navigate = useNavigate();

    useEffect(() => {
        const storedFirstAccess = localStorage.getItem('firstAccess');
        if (storedFirstAccess === 'false') {
            setFirstAccess(false);
        }
        
        // Check if ranking is enabled
        const storedRankingEnable = localStorage.getItem('rankingEnable');
        if (storedRankingEnable === 'true') {
            setRankingEnable(true);
        }
    }, []);

    // Monitor changes in rankingEnable localStorage
    useEffect(() => {
        const checkRankingEnable = () => {
            const storedRankingEnable = localStorage.getItem('rankingEnable');
            setRankingEnable(storedRankingEnable === 'true');
        };

        // Check initially
        checkRankingEnable();

        // Listen for storage events (when localStorage changes in other tabs/windows)
        window.addEventListener('storage', checkRankingEnable);

        // Also check periodically in case localStorage was updated in the same tab
        const interval = setInterval(checkRankingEnable, 1000);

        return () => {
            window.removeEventListener('storage', checkRankingEnable);
            clearInterval(interval);
        };
    }, []);

    const handleLogout = () => {
      // limpa o localStorage sempre que faz o logout
      localStorage.clear();
      // redireciona pra página de login
      navigate('/login');
    };

  return (
    <div className="sidebar">
      <div className='sidebar-content'>
        <ul>
            <li>
            <Link to="/">
              <img src="https://rvensino.com.br/230616_RV_logo_restrito_negativo-branco.png" alt="Logo" className='logo-image' />
            </Link>              
            </li>

              <li>
                <Link to="/dashboard">
                    <DescriptionOutlinedIcon style={{ color: '#fff', fontSize: 45 }} className='sidebar-icon' />
                </Link>
            </li>

            {/* {!firstAccess && (
            )} */}

                <li>
                  <Link to="/historico">
                  <SignalCellularAltOutlinedIcon style={{ color: '#fff', fontSize: 40 }} className='sidebar-icon' />
                  </Link>
                </li>


            {/* {!firstAccess && (
            )} */}

          

            {/*{rankingEnable && (
            )}
            */}

            <li className={!rankingEnable ? 'ranking-disabled' : ''}>
              <Link to="/ranking">
                <EmojiEventsOutlinedIcon style={{ color: '#fff', fontSize: 40 }} className='sidebar-icon' />
              </Link>
            </li>

          <li>
            <Link to="/disciplinas">
            <ImportContactsOutlinedIcon style={{ color: '#fff', fontSize: 40 }} className='sidebar-icon' />
            </Link>
          </li>

          
          <li>
            <Link to="/">
            <PersonOutlineOutlinedIcon style={{ color: '#fff', fontSize: 40 }} className='sidebar-icon' />
            </Link>
          </li>



          <li onClick={handleLogout}>
            <Link to="/login" className='logout'>
                <LogoutOutlinedIcon style={{ color: '#fff', fontSize: 45 }} className='logout-icon'/>
            </Link>
        </li>





        </ul>
      </div>
    </div>
  );
}

export default Sidebar;